import React from 'react';

import blankFlag from '@hydra/assets/flags/blank.gif';

interface IFlagProps {
  country: string
}
export default function Flag ({ country = 'int' }: IFlagProps) {
  return (
    <img
      src={blankFlag}
      className={`flag flag-${country}`}
      alt={`Flag of ${country}`}
    />
  );
}
